// @ts-nocheck
import "@/lib/_jquery";
import "@/entrypoints/shared/log-override";
import Rails from "@rails/ujs";
import "@claviska/jquery-minicolors";
import "@claviska/jquery-minicolors/jquery.minicolors.css";
import "masonry-layout";
import "@/entrypoints/shared/detect_change";
import "@/entrypoints/shared/utils";
import "@/entrypoints/backend_vue";
import "@/entrypoints/backend/wysiwyg";
import "@/entrypoints/shared/sortable";
import "chartkick";
import "chart.js";
import { Tab } from "@assemblyvoting/electa-ui"
// for collapsible sidebar in slide edit view
import { CollapsibleSidebar } from "@/entrypoints/backend/collapsible_sidebar";
import { PreviewImageField } from "@/entrypoints/shared/PreviewImageField";
import "../controllers" // import all Stimulus controllers
// For some reason this plugin won't load even at the end of wysiwyg.ts as it did before
import "trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js";
// The table apparently broke something?
// import "trumbowyg/dist/plugins/table/trumbowyg.table.min.js";
window.Tab = Tab;
import("@rails/activestorage").then(a => a.start());
import("@/entrypoints/shared/sjcl").then(value => window.sjcl = value);

if (!window._rails_loaded) Rails.start();

$(function() {
  $(".collapse-horizontal").each(function () {
    this.collapsibleSidebar = new CollapsibleSidebar(this);
  });
})

// When an input is set inside an element with the data-exclusive="xyz" prop set, all other inputs inside an element
// with data-exclusive="xyz" will be disabled, except the ones in the same element as the source
$(function () {
  $("[data-exclusive]").each(function () {
    const groupName = $(this).data("exclusive");
    const groupElement = $(this);
    $(this).find(":input").on("blur", function () {
      const inputs = $(`[data-exclusive=${groupName}]`).find(":input:not(button):not([type=hidden])");
      const groupInputs = groupElement.find(":input:not(button):not([type=hidden])");
      if (groupInputs.is(function() {return this.value.length > 0 })) {
        inputs.prop("disabled", true);
        groupElement.find(":input").prop("disabled", false);
        inputs.filter("[disabled]").val("");
      } else {
        inputs.prop("disabled", false);
      }
    });
  });
});

$(document).on("change", ".custom-file-input", function() {
  const $label = $(this).prev(".form-label");

  let originalLabel = $label.data("original-label");
  if (originalLabel === undefined) {
    originalLabel = $label.html();
    $label.data("original-label", originalLabel);
  }

  const file = this.files[0];
  if (file) {
    $label.html(file.name);
  } else {
    $label.html(originalLabel);
  }
});

// makes popovers work
$(function() {
  $('[data-bs-toggle="popover"]').popover();
})

// used in election config to select colors (attribute/_color.html.erb)
$(function() {
  $(".js-colorpicker").each((index, node) => {
    $(node).minicolors({
      theme: "bootstrap",
      ...node.dataset,
    });
  });
});

// used for preview images
$(function() {
  $(".js-preview-image").each(function() {
    new PreviewImageField(this);
  });
});

// select all checkboxes button
$(function() {
  const checkboxes = document.querySelectorAll('input[data-all="all"]');
  const allCheckboxbtn = $("#check_all");
  const allUncheckBtn = $("#uncheck_all");

  allUncheckBtn.on("click", function (e) {
    e.preventDefault();

    for (let i = 0; i < checkboxes.length; i++) {
      const item = checkboxes[i];
      item.checked = false;
    }
  });

  allCheckboxbtn.on("click", function(e) {
    e.preventDefault();

    for (let i = 0; i < checkboxes.length; i++) {
      const item = checkboxes[i];
      item.checked = true;
    }
  });
});

$(function() {
  const galleryButton = $("#contest_mode_gallery");
  const listButton = $("#contest_mode_list");
  const fieldsetList = document.getElementById("field_set_tag_list")

  galleryButton.on("click", function (e) {
    if (galleryButton[0].checked) {
      fieldsetList.style.display = "none"
    }
  });
  listButton.on("click", function (e) {
    if (listButton[0].checked) {
      fieldsetList.style.display = "block"
    }
  });
});
